import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import CoursesSection from "./components/CoursesSection";
import BundlesSection from "./components/BundlesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import SocialProofSection from "./components/SocialProofSection";
import Footer from "./components/Footer";
import CoursesPage from "./pages/CoursesPage";
import BundlesPage from "./pages/BundlesPage";
import LearningPathsPage from "./pages/LearningPathsPage";
import CloudCareerQuizPage from "./pages/CloudCareerQuizPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import CookiesPage from "./pages/CookiesPage";
import CloudSupportEngineerPath from "./pages/CloudSupportEngineerPath";
import SolutionsArchitectPath from "./pages/SolutionsArchitectPath";
import CloudEngineerPath from "./pages/CloudEngineerPath";
import AIMLEngineerPath from "./pages/AIMLEngineerPath";
import CloudSecurityEngineerPath from "./pages/CloudSecurityEngineerPath";
import DevOpsEngineerPath from "./pages/DevOpsEngineerPath";
import CloudNewbieBundlePage from "./pages/CloudNewbieBundlePage";
import AllInOneBundlePage from "./pages/AllInOneBundlePage";
import AWSProjectsBundlePage from "./pages/AWSProjectsBundlePage";
import UltimateProjectsBundlePage from "./pages/UltimateProjectsBundlePage";
import AWSInterviewMasteryPage from "./pages/AWSInterviewMasteryPage";
import PartTimeYouTuberPage from "./pages/PartTimeYouTuberPage";
import StudyNotesAIPractitionerPage from "./pages/StudyNotesAIPractitionerPage";
import StudyNotesCloudPractitionerPage from "./pages/StudyNotesCloudPractitionerPage";
import StudyNotesSolutionsArchitectPage from "./pages/StudyNotesSolutionsArchitectPage";
import StudyNotesDeveloperAssociatePage from "./pages/StudyNotesDeveloperAssociatePage";
import StudyNotesCloudOpsPage from "./pages/StudyNotesCloudOpsPage";
import PracticeExamsCloudPractitionerPage from "./pages/PracticeExamsCloudPractitionerPage";
import PracticeExamsAIPractitionerPage from "./pages/PracticeExamsAIPractitionerPage";
import PracticeExamsSolutionsArchitectPage from "./pages/PracticeExamsSolutionsArchitectPage";
import PracticeExamsDeveloperAssociatePage from "./pages/PracticeExamsDeveloperAssociatePage";
import AIMLEngineerProjectsPage from "./pages/AIMLEngineerProjectsPage";
import CloudEngineerProjectsPage from "./pages/CloudEngineerProjectsPage";
import CloudSupportEngineerProjectsPage from "./pages/CloudSupportEngineerProjectsPage";
import SolutionsArchitectProjectsPage from "./pages/SolutionsArchitectProjectsPage";
import CloudSecurityEngineerProjectsPage from "./pages/CloudSecurityEngineerProjectsPage";
import DevOpsEngineerProjectsPage from "./pages/DevOpsEngineerProjectsPage";
import AdvancedAWSProjectsPage from "./pages/AdvancedAWSProjectsPage";
import BeginnerAWSProjectsPage from "./pages/BeginnerAWSProjectsPage";
import AzureBeginnerProjectsPage from "./pages/AzureBeginnerProjectsPage";
import StudyNotesAzureFundamentalsPage from "./pages/StudyNotesAzureFundamentalsPage";
import StudyNotesAzureAdministratorPage from "./pages/StudyNotesAzureAdministratorPage";
import AzureIntermediateProjectsPage from "./pages/AzureIntermediateProjectsPage";
import IntermediateAWSProjectsPage from "./pages/IntermediateAWSProjectsPage";
import FreeCloudFunFactsPage from "./pages/FreeCloudFunFactsPage";
import ZeroToCloudAcceleratorPage from "./pages/ZeroToCloudAcceleratorPage";
import CloudEngineerRoadmapPage from "./pages/CloudEngineerRoadmapPage";
import SolutionsArchitectRoadmapPage from "./pages/SolutionsArchitectRoadmapPage";
import RoadmapDownloadPage from "./pages/RoadmapDownloadPage";
import SARoadmapDownloadPage from "./pages/SARoadmapDownloadPage";
import PromoBanner from "./components/PromoBanner";
import SalePopup from "./components/SalePopup";
import SEO from "./components/SEO";
import { seoData } from "./data/seoData";

const Home = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO {...seoData.home} />
      <SalePopup />
      <PromoBanner />
      <Navigation />
      <HeroSection />
      <CoursesSection />
      <BundlesSection />
      <TestimonialsSection />
      <SocialProofSection />
    
    {/* Newsletter Signup Widget */}
      <section className="py-8 bg-gray-50">
        <div className="container">
          <div className="text-center">
            <script async src="https://subscribe-forms.beehiiv.com/embed.js"></script>
            <iframe 
              src="https://subscribe-forms.beehiiv.com/304b829c-ff1c-4e65-a8aa-1f16f37a0eff" 
              className="beehiiv-embed mx-auto" 
              data-test-id="beehiiv-embed" 
              frameBorder="0" 
              scrolling="no" 
              style={{
                width: '1008px', 
                height: '439px', 
                margin: '0 auto', 
                borderRadius: '0px 0px 0px 0px',
                backgroundColor: 'transparent', 
                boxShadow: '0 0 #0000', 
                maxWidth: '100%'
              }}
            />
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/learning-paths" element={<LearningPathsPage />} />
            <Route path="/learning-paths/cloud-support-engineer" element={<CloudSupportEngineerPath />} />
            <Route path="/learning-paths/solutions-architect" element={<SolutionsArchitectPath />} />
            <Route path="/learning-paths/cloud-engineer" element={<CloudEngineerPath />} />
            <Route path="/learning-paths/cloud-ai-ml-engineer" element={<AIMLEngineerPath />} />
            <Route path="/learning-paths/cloud-security-engineer" element={<CloudSecurityEngineerPath />} />
            <Route path="/learning-paths/devops-engineer" element={<DevOpsEngineerPath />} />
            <Route path="/bundles/cloud-newbie-bundle" element={<CloudNewbieBundlePage />} />
            <Route path="/bundles/all-in-one-bundle" element={<AllInOneBundlePage />} />
            <Route path="/bundles/aws-projects-bundle" element={<AWSProjectsBundlePage />} />
            <Route path="/bundles/ultimate-projects-bundle" element={<UltimateProjectsBundlePage />} />
            <Route path="/courses/aws-interview-mastery" element={<AWSInterviewMasteryPage />} />
            <Route path="/courses/part-time-tech-youtuber" element={<PartTimeYouTuberPage />} />
            <Route path="/courses/study-notes-ai-practitioner" element={<StudyNotesAIPractitionerPage />} />
            <Route path="/courses/study-notes-cloud-practitioner" element={<StudyNotesCloudPractitionerPage />} />
            <Route path="/courses/study-notes-solutions-architect" element={<StudyNotesSolutionsArchitectPage />} />
            <Route path="/courses/study-notes-developer-associate" element={<StudyNotesDeveloperAssociatePage />} />
            <Route path="/courses/study-notes-cloudops" element={<StudyNotesCloudOpsPage />} />
            <Route path="/courses/practice-exams-cloud-practitioner" element={<PracticeExamsCloudPractitionerPage />} />
            <Route path="/courses/practice-exams-ai-practitioner" element={<PracticeExamsAIPractitionerPage />} />
            <Route path="/courses/practice-exams-solutions-architect" element={<PracticeExamsSolutionsArchitectPage />} />
            <Route path="/courses/practice-exams-developer-associate" element={<PracticeExamsDeveloperAssociatePage />} />
            <Route path="/courses/ai-ml-engineer-projects" element={<AIMLEngineerProjectsPage />} />
            <Route path="/courses/cloud-engineer-projects" element={<CloudEngineerProjectsPage />} />
            <Route path="/courses/cloud-support-engineer-projects" element={<CloudSupportEngineerProjectsPage />} />
            <Route path="/courses/solutions-architect-projects" element={<SolutionsArchitectProjectsPage />} />
            <Route path="/courses/cloud-security-engineer-projects" element={<CloudSecurityEngineerProjectsPage />} />
            <Route path="/courses/devops-engineer-projects" element={<DevOpsEngineerProjectsPage />} />
            <Route path="/courses/advanced-aws-projects" element={<AdvancedAWSProjectsPage />} />
            <Route path="/courses/beginner-aws-projects" element={<BeginnerAWSProjectsPage />} />
            <Route path="/courses/azure-beginner-projects" element={<AzureBeginnerProjectsPage />} />
            <Route path="/course/5-beginner-azure-cloud-projects" element={<AzureBeginnerProjectsPage />} />
            <Route path="/courses/study-notes-azure-fundamentals" element={<StudyNotesAzureFundamentalsPage />} />
            <Route path="/course/study-notes-azure-fundamentals" element={<StudyNotesAzureFundamentalsPage />} />
            <Route path="/courses/study-notes-azure-administrator" element={<StudyNotesAzureAdministratorPage />} />
            <Route path="/course/study-notes-azure-administrator-associate" element={<StudyNotesAzureAdministratorPage />} />
            <Route path="/courses/azure-intermediate-projects" element={<AzureIntermediateProjectsPage />} />
            <Route path="/course/5-intermediate-azure-cloud-projects" element={<AzureIntermediateProjectsPage />} />
            <Route path="/courses/intermediate-aws-projects" element={<IntermediateAWSProjectsPage />} />
            <Route path="/courses/free-cloud-fun-facts" element={<FreeCloudFunFactsPage />} />
            <Route path="/free/cloud-engineer-roadmap" element={<CloudEngineerRoadmapPage />} />
            <Route path="/free/solutions-architect-roadmap" element={<SolutionsArchitectRoadmapPage />} />
            <Route path="/roadmap-download" element={<RoadmapDownloadPage />} />
            <Route path="/sa-roadmap-download" element={<SARoadmapDownloadPage />} />
            
            {/* NEW ROUTES - Matching your publicly posted URLs */}
            <Route path="/course/5-beginner-aws-cloud-projects" element={<BeginnerAWSProjectsPage />} />
            <Route path="/course/5-intermediate-aws-cloud-projects" element={<IntermediateAWSProjectsPage />} />
            <Route path="/course/5-advanced-aws-cloud-projects" element={<AdvancedAWSProjectsPage />} />
            <Route path="/course/ai-practitioner-notes" element={<StudyNotesAIPractitionerPage />} />
            <Route path="/course/cloud-practitioner-notes" element={<StudyNotesCloudPractitionerPage />} />
            <Route path="/course/solutions-architect-associate-notes" element={<StudyNotesSolutionsArchitectPage />} />
            <Route path="/course/aws-interview-mastery" element={<AWSInterviewMasteryPage />} />
            <Route path="/course/the-part-time-tech-career-youtuber" element={<PartTimeYouTuberPage />} />
            
            {/* ADDITIONAL COURSE ROUTES */}
            <Route path="/course/free-project-aws-cloud-fun-facts-generator" element={<FreeCloudFunFactsPage />} />
            <Route path="/course/aws-cloud-practitioner-practice-tests" element={<PracticeExamsCloudPractitionerPage />} />
            <Route path="/course/aws-certified-ai-practitioner-practice-tests" element={<PracticeExamsAIPractitionerPage />} />
            <Route path="/course/5-aws-cloud-projects-cloud-engineer" element={<CloudSupportEngineerProjectsPage />} />
            <Route path="/course/5-aws-cloud-projects-to-become-a-solutions-architect" element={<SolutionsArchitectProjectsPage />} />
            <Route path="/course/5-aws-projects-to-become-a-cloud-security-engineer" element={<CloudSecurityEngineerProjectsPage />} />
            
            {/* BUNDLE ROUTES (singular) */}
            <Route path="/bundle/aws-projects-bundle" element={<AWSProjectsBundlePage />} />
            <Route path="/bundle/cloud-newbie-bundle" element={<CloudNewbieBundlePage />} />
            <Route path="/bundle/zero-to-cloud-all-in-one-bundle" element={<AllInOneBundlePage />} />
            
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/bundles" element={<BundlesPage />} />
            <Route path="/accelerator" element={<ZeroToCloudAcceleratorPage />} />
            <Route path="/cloud-role-quiz" element={<CloudCareerQuizPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsAndConditionsPage />} />
            <Route path="/cookies" element={<CookiesPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
